var React = require('react');

function ChevronRightAlternative (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.30433 0.831216L9.18145 8.00882C9.3493 8.18253 9.43265 8.4077 9.43265 8.63192C9.43265 8.85615 9.3493 9.08151 9.18145 9.25503L2.30433 16.4326C1.96059 16.793 1.39014 16.8047 1.03107 16.4596C0.669557 16.1169 0.6578 15.5439 1.00408 15.186L7.31404 8.59807L1.00515 2.07781C0.658891 1.721 0.670648 1.14709 1.03214 0.804173C1.39126 0.459 1.96254 0.47102 2.30433 0.831216Z","fill":"currentColor"}));
}

ChevronRightAlternative.defaultProps = {"width":"10","height":"17","viewBox":"0 0 10 17","fill":"none"};

module.exports = ChevronRightAlternative;

ChevronRightAlternative.default = ChevronRightAlternative;
